function refreshRowLayout(row) {
    const rowElement = row.getElement();
    const tableholder = rowElement.closest('.tabulator-tableholder');
    const scrollTop = tableholder?.scrollTop;

    row.normalizeHeight?.();

    if (tableholder && typeof scrollTop === 'number') {
        tableholder.scrollTop = scrollTop;
    }

    document.dispatchEvent(new CustomEvent('tabulatorNestedTableToggled'));
}

export default function (cell, formatterParams, onRendered) {
    const button = document.createElement('button');
    button.className = 'btn-table-menu collapse';
    button.innerHTML = '<span class="icon-arrow_down"></span>';

    button.addEventListener('click', function (e) {
        e.stopPropagation();
        const row = cell.getRow();
        const rowElement = row.getElement();
        const nestedTableContainer = rowElement.querySelector(
            '.nested-table-container',
        );
        nestedTableContainer.classList.toggle('hidden');
        button.classList.toggle('active');

        window.requestAnimationFrame(() => {
            refreshRowLayout(row);
            window.setTimeout(() => refreshRowLayout(row), 50);
        });
    });
    return button;
}
